module.exports = __webpack_public_path__ + "img/1970East-063_WEB-min.93940960.jpg";